import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { SUPPORTED_IMAGE_TYPES } from '../../../../../constants/file.constants';
import DefaultButton from '../../../../global/default-button/default-button';
import { IDefaultImage } from './upload-image-to-s3.viewmodel';
import { FileInput } from '../file-input/file-input';
import './upload-image.scss';
import { REMOVE_TEXT } from '../../../../../constants/common-labels.constants';
export interface IUploadImageProps {
    imgSrc: string;
    imgName: string;
    onChange?: (e?: React.ChangeEvent<HTMLInputElement>) => void | null;
    deleteImage: () => void | null;
    disabled?: boolean;
    readOnly?: boolean;
    isChangeDisabled?: boolean;
    withSVGType?: boolean;
    showDefaultImage?: boolean;
    defaultImage?: IDefaultImage;
}

const UploadImage = (props: IUploadImageProps) => {
    const {
        imgSrc,
        imgName,
        onChange,
        deleteImage,
        disabled = true,
        readOnly = true,
        isChangeDisabled = false,
        withSVGType = true,
        defaultImage,
        showDefaultImage = false,
    } = props;

    const [display, setDisplay] = useState(false);

    const acceptedFileTypes = withSVGType ? SUPPORTED_IMAGE_TYPES.join() : SUPPORTED_IMAGE_TYPES.filter(el => el !== 'image/svg+xml').join();

    return (
        <div className='uploaded-img'>
            <div className='uploaded-img__preview'>
                {!showDefaultImage
                    ? (imgSrc &&
                        <img
                            src={imgSrc}
                            alt='photo'
                            style={{
                                opacity: display ? '100%' : 0,
                                transition: `opacity 0.35s ease`
                            }}
                            onLoad={() => setDisplay(true)}
                        />)
                    : typeof defaultImage.ImgSrc === 'string'
                    ? <img src={defaultImage.ImgSrc} alt={defaultImage.imageTitle} />
                    : <defaultImage.ImgSrc />
                }

            </div>
            <div className='uploaded-img__name'>
                <div>
                    <input
                        className='oe-form-field__control m-right-11px uploaded-img__name--title'
                        type='text'
                        value={!showDefaultImage ? imgName : defaultImage.imageTitle}
                        readOnly={readOnly}
                        disabled={disabled}
                    />
                </div>
                {!showDefaultImage &&
                    <div className='image-input flex w-100 m-top-10px p-top-2px uploaded-img__controls'>
                        {onChange &&
                            <FileInput
                                className='default-button--slim default-button--options m-right-5px'
                                type='default'
                                title={
                                    <FormattedMessage
                                            id = 'oe.common.replace'
                                            description = 'Button label'
                                            defaultMessage = 'Replace'
                                        />
                                }
                                acceptedFileTypes={acceptedFileTypes}
                                onChange={onChange}
                                disabled={isChangeDisabled}
                            />
                        }
                        {deleteImage && <DefaultButton
                            onClick={deleteImage}
                            text={<FormattedMessage {...REMOVE_TEXT} />}
                            modifier='remove'
                        />
                        }
                    </div>
                }
            </div>
        </div>
    );
};

export default UploadImage;
